import React from "react";
import SignupForm from "../Components/LoginAndSignup/Signup/SignupForm";

const Signup = () => {
  return (
    <SignupForm />
  );
};

export default Signup;
